module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block form form-horizontal"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'dropdown-has-error': _vm.$v.model.id_pais.$error
    }
  }, [_c('label', [_vm._v("País*")]), _vm._v(" "), _c('select-api', {
    ref: "selectPais",
    attrs: {
      "endpoint": '/pais/pesquisa',
      "opt-text": 'nome',
      "select-option": true
    },
    model: {
      value: (_vm.model.id_pais),
      callback: function($$v) {
        _vm.$set(_vm.model, "id_pais", $$v)
      },
      expression: "model.id_pais"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'dropdown-has-error': _vm.$v.model.tipo.$error
    }
  }, [_c('label', [_vm._v("Tipo*")]), _vm._v(" "), _c('Select2', {
    attrs: {
      "placeholder": "Selecione",
      "options": _vm.tipos,
      "opt-id": "tipo"
    },
    model: {
      value: (_vm.model.tipo),
      callback: function($$v) {
        _vm.$set(_vm.model, "tipo", $$v)
      },
      expression: "model.tipo"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Selecione")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'has-danger': _vm.$v.model.nome.$error
    }
  }, [_c('label', [_vm._v("Nome*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.nome),
      expression: "model.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.model.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Telefone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.telefone),
      expression: "model.telefone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.model.telefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "telefone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("E-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.email),
      expression: "model.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.model.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Site")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.site),
      expression: "model.site"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.model.site)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "site", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Descrição")]), _vm._v(" "), _c('dw-textarea', {
    on: {
      "input": function($event) {
        _vm.$v.model.descricao.$touch()
      }
    },
    model: {
      value: (_vm.model.descricao),
      callback: function($$v) {
        _vm.$set(_vm.model, "descricao", $$v)
      },
      expression: "model.descricao"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Horário")]), _vm._v(" "), _c('dw-textarea', {
    on: {
      "input": function($event) {
        _vm.$v.model.horario.$touch()
      }
    },
    model: {
      value: (_vm.model.horario),
      callback: function($$v) {
        _vm.$set(_vm.model, "horario", $$v)
      },
      expression: "model.horario"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Procedimento")]), _vm._v(" "), _c('dw-textarea', {
    on: {
      "input": function($event) {
        _vm.$v.model.procedimento.$touch()
      }
    },
    model: {
      value: (_vm.model.procedimento),
      callback: function($$v) {
        _vm.$set(_vm.model, "procedimento", $$v)
      },
      expression: "model.procedimento"
    }
  })], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('file-image', {
    attrs: {
      "label": 'Imagem',
      "arquivo": _vm.model.arquivo
    },
    model: {
      value: (_vm.imagem),
      callback: function($$v) {
        _vm.imagem = $$v
      },
      expression: "imagem"
    }
  })], 1)])])]), _vm._v(" "), _c('dw-form-address', {
    ref: "formAddress",
    attrs: {
      "pais": _vm.pais,
      "id-pais": _vm.model.id_pais,
      "model": _vm.model.endereco
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-footer text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-link",
    attrs: {
      "to": {
        name: 'list-clinic'
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Salvar")])], 1)])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Credenciada\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('strong', [_vm._v("Atenção!")]), _vm._v("\n                            O tamanho máximo e indicado para a\n                            "), _c('strong', [_vm._v("Imagem")]), _vm._v(" é de\n                            "), _c('strong', [_vm._v("300kb")]), _vm._v(".\n                        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58dbe12e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/clinic/Form.vue
// module id = 868
// module chunks = 1